import getLanguage from 'ToolboxUtils/web/cookie/get-language';

export default getLanguage("chuchoteurs" + window.location.hostname + "Language");
